import surveysRoutes from 'modules/trainingLibrary/Surveys/routing/routes'

const routes = {
  root: `${surveysRoutes.root}/details`,
}

export default routes
